import { Component, OnInit } from '@angular/core';
import { aagPersistentStorage } from '../../services/sessionmanager.service';
import { Router } from '@angular/router';
import { Student } from '../../model/student';
import { AuthService } from '../../services/auth.service';
import { aagSessionStorageConstants } from '../../constants/ui-constants';
import { WorkgroupService } from '../../services/workgroup.service';

@Component({
  selector: 'app-hotel-details',
  templateUrl: './hotel-details.component.html',
  styleUrls: ['./hotel-details.component.scss'],
})
export class HotelDetailsComponent implements OnInit {
  student: Student;
  public aagSiteContactEmail: string;

  constructor(private persistenceSvc: aagPersistentStorage, private router: Router, private workgroupService: WorkgroupService) {
    // console.debug('Event..HotelDetailsComponent(DEBUG) CONSTRUCTOR initialize.................' + new Date().toLocaleString());
  }

  ngOnInit() {
    this.student = this.persistenceSvc.read(aagSessionStorageConstants.SESSIONSTUDENT);
    if (!this.student) {
      this.router.navigateByUrl('/');
      return;
    }

    this.aagSiteContactEmail = this.workgroupService.getCurrentBusinessSupportContact();
  }

  signOut() {
    this.persistenceSvc.write(aagSessionStorageConstants.SESSSIONRESET, 'NOW');
    this.router.navigateByUrl('/');
  }
}
